import React, { useState } from 'react';
import { DropdownToggle, DropdownMenu, Dropdown } from 'reactstrap';
import { RoomSearchInfo } from '@/__generated';
import { BoardType } from '@/constants';
import { useTranslation } from 'react-i18next';

interface Props {
  boardType: number;
  onChange: (boardType: number) => void;
}

const MealSearch = ({ onChange, boardType }: Props) => {
  const { t } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => {
    setDropdownOpen(x => !x);
  };

  return (
    <div className=" px-30 xl:py-20 xl:px-0 js-form-dd js-form-counters position-relative rounded-0">
      <h4 className="text-15 fw-500 ls-2 lh-16">{t('homePage_BoardType')}</h4>
      <Dropdown tag="div" isOpen={dropdownOpen} toggle={toggle} className="text-15 text-light-1 ls-2 lh-16">
        <DropdownToggle tag="div" className="d-block w-100">
          {BoardType.__getValue(boardType)}
        </DropdownToggle>
        <DropdownMenu tag="div" className="search-box-transition shadow-2 dropdown-menu min-width-300 mt-20 cursor-default">
          <div className="bg-white px-20 py-20 rounded-4 ">
            {BoardType.__getSelectOptions().map(meal => {
              const activeClass = boardType === meal.value ? 'bg-blue-1 text-white  ' : 'text-blue-1 bg-white';
              return (
                <div key={meal.value}>
                  <button
                    onClick={() => {
                      onChange(meal.value);
                      toggle();
                    }}
                    className={`button rounded  fw-500 text 14  border-light px-20 py-10 mb-10 ${activeClass}`}
                  >
                    {meal.label}
                  </button>
                </div>
              );
            })}
          </div>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};
export default MealSearch;
